import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/views/Index'
import Guide from '@/views/Guide'
import Result from '@/views/Result'
import SelectProducer from '@/views/SelectProducer'
import SelectVaccine from '@/views/SelectVaccine'
import MultiMacheing from '@/views/MultiMacheing'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Guide',
      name: 'Guide',
      component: Guide
    },
    {
      path: '/Result/:id?',
      name: 'Result',
      component: Result
    },
    {
      path: '/SelectProducer',
      name: 'SelectProducer',
      component: SelectProducer
    },
    {
      path: '/SelectVaccine',
      name: 'SelectVaccine',
      component: SelectVaccine
    }
    // ,去掉多结果匹配
    // {      
    //   path: '/MultiMacheing',
    //   name: 'MultiMacheing',
    //   component: MultiMacheing
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js